<template>
  <div class="confirm-unlock">
    <HKLModal
      ref="confirmModal"
      :title="$t('hint.unlock.success')"
      :afterClose="navToLogin"
      :hasCancelBtn="false"
      :closable="true"
    />
    <HKLModal
      ref="rejectModal"
      :afterClose="navToLogin"
      :hasCancelBtn="false"
      :closable="true"
    >
      <template slot="title">
        <pre>{{ $t('hint.unlock.fail') }}</pre>
      </template>
    </HKLModal>
  </div>
</template>

<script>

import { getCurrentInstance, onMounted } from 'vue-demi'
import HKLModal from '@/controls/Modal/HKLModal'
import { useRefModal } from '@/controls/Modal/modal.hook'
import Status from 'http-status-codes'
import lodash from 'lodash'
import notification from '@/utils/notification'
import { confirmUnlock } from '@/api/auth/request'
import { getRegionsAndSetCurrent, switchLangByRegion } from './utils'

export default {
  components: {
    HKLModal,
  },
  setup () {
    const { modal: confirmModal, open: openConfirmModal } = useRefModal()
    const { modal: rejectModal, open: openRejectModal } = useRefModal()
    const { proxy } = getCurrentInstance()

    async function checkToken () {
      try {
        const token = proxy.$router.currentRoute.query.token

        if (token) {
          await confirmUnlock(token)
        }
        openConfirmModal()
      } catch (err) {
        const status = lodash.get(err, 'response.status')
        if (Status.BAD_REQUEST === status) {
          openRejectModal()
        } else {
          notification.handleResponseError(err)
        }
      }
    }
    function navToLogin () {
      proxy.$router.push({ name: 'publicLogin' })
    }
    onMounted(async () => {
      const regionName = proxy.$router.currentRoute.query.region
      await getRegionsAndSetCurrent(regionName)
      switchLangByRegion(regionName)
      await checkToken()
    })
    return {
      confirmModal,
      openConfirmModal,
      rejectModal,
      openRejectModal,
      checkToken,
      navToLogin,
    }
  },

}
</script>

  <style lang="scss" scoped>
  @import '~styles/popup';

  </style>
  <style scoped src="styles/dashboard/style.scss"></style>
